import ExecutionEnvironment from 'exenv';

import { useFeature } from 'hooks/useFeature';
import useMartyContext from 'hooks/useMartyContext';
import { FEATURE_SITE_REDESIGN } from 'constants/features';
import { HYDRA_ZAPPOS_REDESIGN } from 'constants/hydraTests';
import { useInAssignment } from 'hooks/useHydra';

const THEME_ATTR = 'data-theme';
const THEME_VAL = 'zappos-redesign';
const CLASS_THEME_ATTR = 'class';
const THEME_6PM = 'sixpm';
const SHORT_NAME_6PM = '6pm';

const Themer = () => {
  const isHydraZapposRedesign = useInAssignment(HYDRA_ZAPPOS_REDESIGN);
  const hasZapposRedesignFeature = useFeature(FEATURE_SITE_REDESIGN);
  const { marketplace: { shortName } = {} } = useMartyContext();

  if (!ExecutionEnvironment.canUseDOM) {
    return null;
  }

  const root = document.documentElement;

  if (isHydraZapposRedesign || hasZapposRedesignFeature) {
    root?.setAttribute(THEME_ATTR, THEME_VAL);
  } else {
    root?.removeAttribute(THEME_ATTR);
  }

  if (shortName === SHORT_NAME_6PM) {
    root?.setAttribute(CLASS_THEME_ATTR, THEME_6PM);
  } else {
    root?.removeAttribute(CLASS_THEME_ATTR);
  }

  return null;
};

export default Themer;
